export default "__VITE_ASSET__3b82fc96__"